import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, QueryEntity } from '@datorama/akita';

import { SupplementalSectionPromptsState, SupplementalSectionPromptsStore } from './supplemental-section-prompts.store';

@Injectable({ providedIn: 'root' })
export class SupplementalSectionPromptsQuery extends QueryEntity<SupplementalSectionPromptsState> {
  protected store: SupplementalSectionPromptsStore;

  static instance: SupplementalSectionPromptsQuery;
  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(SupplementalSectionPromptsStore);

    super(store);
    this.store = store;

    SupplementalSectionPromptsQuery.instance = this;
  }
}
